import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function ArrowUp({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>ArrowUp</title>
      <path
        d="M12 20L12 4M12 4L18 10M12 4L6 10"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
